function initCountdown(el, options, callback) {
  if (!el) return;

  var settings = Object.assign({
    date: null,
    offset: null,
    day: 'Day',
    days: 'Days',
    hour: 'Hour',
    hours: 'Hours',
    minute: 'Minute',
    minutes: 'Minutes',
    second: 'Second',
    seconds: 'Seconds'
  }, options);

  if (!settings.date) {
    throw new Error('Date is not defined.');
  }

  if (!Date.parse(settings.date)) {
    throw new Error('Incorrect date format, it should look like this, 12/24/2012 12:00:00.');
  }

  function currentDate() {
    var date = new Date();
    var utc = date.getTime() + (date.getTimezoneOffset() * 60000);
    return new Date(utc + (3600000 * settings.offset));
  }

  function setText(selector, value) {
    var node = el.querySelector(selector);
    if (node) node.textContent = value;
  }

  function countdown() {
    var target_date  = new Date(settings.date);
    var current_date = currentDate();
    var difference   = target_date - current_date;

    var timerEl = document.querySelector('.header-countdown-timer');
    if (timerEl) {
      timerEl.style.display = '';
      timerEl.classList.add('timer-visible');
    }

    if (difference < 0) {
      clearInterval(interval);
      if (typeof callback === 'function') callback(el);
      return;
    }

    var _second  = 1000;
    var _minute  = _second * 60;
    var _hour    = _minute * 60;
    var _day     = _hour * 24;

    var days    = Math.floor(difference / _day);
    var hours   = Math.floor((difference % _day)    / _hour);
    var minutes = Math.floor((difference % _hour)   / _minute);
    var seconds = Math.floor((difference % _minute) / _second);

    var text_days    = (days === 1)    ? settings.day    : settings.days;
    var text_hours   = (hours === 1)   ? settings.hour   : settings.hours;
    var text_minutes = (minutes === 1) ? settings.minute : settings.minutes;
    var text_seconds = (seconds === 1) ? settings.second : settings.seconds;

    days    = String(days).length    >= 2 ? String(days)    : '0' + days;
    hours   = String(hours).length   >= 2 ? String(hours)   : '0' + hours;
    minutes = String(minutes).length >= 2 ? String(minutes) : '0' + minutes;
    seconds = String(seconds).length >= 2 ? String(seconds) : '0' + seconds;

    setText('.days1',    days[0]);
    setText('.days2',    days[1]);
    setText('.hours1',   hours[0]);
    setText('.hours2',   hours[1]);
    setText('.minutes1', minutes[0]);
    setText('.minutes2', minutes[1]);
    setText('.seconds1', seconds[0]);
    setText('.seconds2', seconds[1]);

    setText('.days_text',    text_days);
    setText('.hours_text',   text_hours);
    setText('.minutes_text', text_minutes);
    setText('.seconds_text', text_seconds);
  }

  var interval = setInterval(countdown, 1000);
}

function updateTop() {
  var utilBar = document.querySelector('.utility-bar');
  if (!utilBar) return;

  var height  = utilBar.offsetHeight;
  var styleEl = document.getElementById('ancss');

  if (!styleEl) {
    styleEl    = document.createElement('style');
    styleEl.id = 'ancss';
    document.head.appendChild(styleEl);
  }

  styleEl.textContent = '.shopify-section-header-sticky { top: ' + height + 'px; }';
}

document.addEventListener('DOMContentLoaded', function () {
  var timerEl = document.querySelector('.announcement-bar-timer');
  if (timerEl) {
    initCountdown(timerEl, {
      date:   timerEl.dataset.time,
      offset: timerEl.dataset.timezone,
      day:    'Day',
      days:   'Days'
    }, function (el) {
      el.remove();
    });
  }

  updateTop();
});

window.addEventListener('resize', updateTop);
